angular.module('impactx.search').service('SearchService', [
    'dataGen',
    'searchFilter',
    '$routeParams',
    'TranslationService',
    'SearchProcessService',
    'SearchExecution',
    'SearchFilter',
    'AppConfiguration',
    'SearchFilterStorage',
    '$rootScope',
    SearchService
]);

function SearchService(dataGen, searchFilter, $routeParams, TranslationService, SearchProcessService, SearchExecution, SearchFilter, AppConfiguration,
                       SearchFilterStorage, $rootScope) {
    var self = this;
    var NUMBER_OF_PRODUCTS = AppConfiguration.get('numberOfProductsInSearch');
    var NUMBER_OF_TENDERS = AppConfiguration.get('numberOfTendersInSearch');
    var NUMBER_OF_LOTS = AppConfiguration.get('numberOfLotsInSearch');
    var NUMBER_OF_CATALOGS = AppConfiguration.get('numberOfCatalogsInSearch');
    var NUMBER_OF_SUPPLIERS = AppConfiguration.get('numberOfSuppliersInSearch');

    var initWatcher = $rootScope.$watch(function () {
        return AppConfiguration.get('numberOfCatalogsInSearch')
    }, function (newValue) {
        if (newValue) {
            NUMBER_OF_PRODUCTS = AppConfiguration.get('numberOfProductsInSearch');
            NUMBER_OF_TENDERS = AppConfiguration.get('numberOfTendersInSearch');
            NUMBER_OF_LOTS = AppConfiguration.get('numberOfLotsInSearch');
            NUMBER_OF_CATALOGS = AppConfiguration.get('numberOfCatalogsInSearch');
            NUMBER_OF_SUPPLIERS = AppConfiguration.get('numberOfSuppliersInSearch');
            initWatcher();
        }
    });

    var userSearchConfig = {
        expandTenderLotDefault: null,
        expandCatalogSupplierDefault: null,
        showCategoryFilters: null,
        showFacets: null,
        showGeneralFilters: null,
        informationIsOpen: true
    };

    var searchId;

    self.products = [];
    self.numberOfProducts = 8;
    self.tenders = [];
    self.numberOfTenders = 0;
    self.lots = [];
    self.numberOfLots = 0;
    self.catalogs = [];
    self.numberOfCatalogs = 0;
    self.suppliers = [];
    self.numberOfSuppliers = 0;
    self.themeWorlds = [];
    self.numberOfThemeWorlds = 0;
    self.productGroups = [];
    self.numberOfProductGroups = 0;
    self.trns = {};
    self.maxPageNumberProducts = 0;
    self.maxPageNumberTenders = 0;
    self.maxPageNumberLots = 0;
    self.maxPageNumberCatalogs = 0;
    self.maxPageNumberSuppliers = 0;
    self.header = null;
    self.headerText = null;
    self.lastSearchInput = null;
    self.globalSearchFocused = false;

    self.userSearchConfig = function (parameterName) {
        var userSearchConfigElement = userSearchConfig[parameterName];
        if (userSearchConfigElement == null) {
            return AppConfiguration.get(parameterName);
        }
        else {
            return userSearchConfigElement;
        }
    };

    self.setUserSearchConfigParameter = function (parameterName, value) {
        userSearchConfig[parameterName] = value;
    };

    // i would really like to refactor this to avoid this data juggling. but there is no way without breaking a lot of stuff
    self.searchAll = function (filter, endpoint) {
        if (!endpoint) {
            endpoint = "/search/all";
        }
        return search(endpoint, filter).then(function (response) {
            var tenders = impactX.isDefined(response, 'data.searchResults.tenders');
            if (tenders) {
                self.tenders = tenders;
                self.numberOfTenders = impactX.isDefined(response, 'data.searchResults.numOfTenders');
            } else {
                self.tenders = [];
                self.numberOfTenders = 0;
            }
            var lots = impactX.isDefined(response, 'data.searchResults.lots');
            if (lots) {
                self.lots = lots;
                self.numberOfLots = impactX.isDefined(response, 'data.searchResults.numOfLots');
            } else {
                self.lots = [];
                self.numberOfLots = 0;
            }
            var catalogs = impactX.isDefined(response, 'data.searchResults.catalogs');
            if (catalogs) {
                self.catalogs = catalogs;
                self.numberOfCatalogs = impactX.isDefined(response, 'data.searchResults.numOfCats');
            } else {
                self.catalogs = [];
                self.numberOfCatalogs = 0;
            }
            var suppliers = impactX.isDefined(response, 'data.searchResults.suppliers');
            if (suppliers) {
                self.suppliers = suppliers;
                self.numberOfSuppliers = impactX.isDefined(response, 'data.searchResults.numOfSuppliers');
            } else {
                self.suppliers = [];
                self.numberOfSuppliers = 0;
            }
            var products = impactX.isDefined(response, 'data.searchResults.products');
            if (products) {
                self.products = products;
                self.numberOfProducts = impactX.isDefined(response, 'data.searchResults.numOfProducts');
                self.maxPageNumberProducts = Math.floor(self.numberOfProducts / NUMBER_OF_PRODUCTS) + (self.numberOfProducts % NUMBER_OF_PRODUCTS > 0 ? 1 : 0);
            } else {
                self.products = [];
                self.numberOfProducts = 0;
                self.maxPageNumberProducts = 0;
            }
            var productGroups = impactX.isDefined(response, 'data.searchResults.productGroups');
            if (productGroups) {
                self.productGroups = productGroups;
                self.numberOfProductGroups = impactX.isDefined(response, 'data.searchResults.numOfProductGroups');
            } else {
                self.productGroups = [];
                self.numberOfProductGroups = 0;
            }
            if (AppConfiguration.get('showThemeWorldTab')) {
                var themeWorlds = impactX.isDefined(response, 'data.searchResults.themeWorlds');
                if (themeWorlds) {
                    self.themeWorlds = themeWorlds;
                    self.numberOfThemeWorlds = impactX.isDefined(response, 'data.searchResults.numOfThemeWorlds');
                } else {
                    self.themeWorlds = [];
                    self.numberOfThemeWorlds = 0;
                }
            }
            var alternativeSearchTerms = impactX.isDefined(response, 'data.searchResults.alternativeSearchTerms');
            if (alternativeSearchTerms) {
                self.alternativeSearchTerms = alternativeSearchTerms;
            }

            self.trns = impactX.isDefined(response, 'trns');
            self.header = impactX.isDefined(response, 'data.searchResults.header');
            self.headerText = impactX.isDefined(response, 'data.searchResults.headerText');
            SearchFilterStorage.setSearchFilterPlaceHolder(impactX.isDefined(response, 'data.searchPlaceHolder'));
            SearchFilterStorage.setCanResetSearchInput(impactX.isDefined(response, 'data.canResetSearchInput'));
            return getSearchResults();
        })
    };

    self.searchProducts = function (pageNumber, filters) {
        return SearchExecution.searchProducts(filters ? filters : SearchFilter.getFilters(), NUMBER_OF_PRODUCTS, pageNumber).then(function (searchResults) {
            if (searchResults) {
                self.products = searchResults.products;
                self.numberOfProducts = searchResults.numOfProducts;
                self.maxPageNumberProducts = Math.floor(self.numberOfProducts / NUMBER_OF_PRODUCTS) + (self.numberOfProducts % NUMBER_OF_PRODUCTS > 0 ? 1 : 0);

                return {
                    products: self.products,
                    numberOfProducts: self.numberOfProducts,
                    maxPageNumber: self.maxPageNumberProducts
                }
            }
        });
    };

    self.searchTenders = function (pageNumber, pageSize, filters) {
        return SearchExecution.searchTenders(filters ? filters : SearchFilter.getFilters(), pageSize || NUMBER_OF_TENDERS, pageNumber).then(function (result) {
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.tenders = searchResults.tenders;
                self.numberOfTenders = searchResults.numOfTenders;
                self.maxPageNumberTenders = Math.floor(self.numberOfTenders / NUMBER_OF_TENDERS) + 1;

                return {
                    tenders: self.tenders,
                    numberOfTenders: self.numberOfTenders,
                    maxPageNumberTenders: self.maxPageNumberTenders,
                    trns: result.trns
                }
            }
        });
    };

    self.searchLots = function (pageNumber, pageSize, filters) {
        return SearchExecution.searchLots(filters ? filters : SearchFilter.getFilters(), pageSize || NUMBER_OF_LOTS, pageNumber).then(function (result) {
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.lots = searchResults.lots;
                self.numberOfLots = searchResults.numOfLots;
                self.maxPageNumberLots = Math.floor(self.numberOfLots / NUMBER_OF_LOTS) + 1;

                return {
                    lots: self.lots,
                    numberOfLots: self.numberOfLots,
                    maxPageNumberLots: self.maxPageNumberLots,
                    trns: result.trns
                }
            }
        });
    };

    self.searchCatalogs = function (pageNumber, pageSize, filters) {
        return SearchExecution.searchCatalogs(filters ? filters : SearchFilter.getFilters(), pageSize || NUMBER_OF_CATALOGS, pageNumber).then(function (result) {
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.catalogs = searchResults.catalogs;
                self.numberOfCatalogs = searchResults.numOfCats;
                self.maxPageNumberCatalogs = Math.floor(self.numberOfCatalogs / NUMBER_OF_CATALOGS) + 1;

                return {
                    catalogs: self.catalogs,
                    numberOfCatalogs: self.numberOfCatalogs,
                    maxPageNumberCatalogs: self.maxPageNumberCatalogs,
                    trns: result.trns
                }
            }
        });
    };

    self.searchSuppliers = function (pageNumber, pageSize, filters) {
        return SearchExecution.searchSuppliers(filters ? filters : SearchFilter.getFilters(), pageSize || NUMBER_OF_SUPPLIERS, pageNumber).then(function (result) {
            if (result && result.data) {
                var searchResults = result.data.searchResults;
                self.suppliers = searchResults.suppliers;
                self.numberOfSuppliers = searchResults.numOfSuppliers;
                self.maxPageNumberSuppliers = Math.floor(self.numberOfSuppliers / NUMBER_OF_SUPPLIERS) + 1;

                return {
                    suppliers: self.suppliers,
                    numberOfSuppliers: self.numberOfSuppliers,
                    maxPageNumberSuppliers: self.maxPageNumberSuppliers,
                    trns: result.trns
                }
            }
        });
    };

    function getSearchResults() {
        return {
            products: self.products,
            numberOfProducts: self.numberOfProducts,
            tenders: self.tenders,
            numberOfTenders: self.numberOfTenders,
            lots: self.lots,
            numberOfLots: self.numberOfLots,
            catalogs: self.catalogs,
            numberOfCatalogs: self.numberOfCatalogs,
            suppliers: self.suppliers,
            numberOfSuppliers: self.numberOfSuppliers,
            themeWorlds: self.themeWorlds,
            numberOfThemeWorlds: self.numberOfThemeWorlds,
            productGroups: self.productGroups,
            numberOfProductGroups: self.numberOfProductGroups,
            trns: self.trns,
            maxPageNumber: self.maxPageNumberProducts,
            header: self.header,
            headerText: self.headerText,
            alternativeSearchTerms: self.alternativeSearchTerms
        }
    }

    // old stuff
    var searchService = this;
    this.lastTopIndexProductSearch = {value: 0};
    this.consumableTopIndexProductSearch = {value: 0};
    this.consumableTopIndexOtherProductSearch = {value: 0};
    this.model = {};
    this.model.data = {};

    function updateLabels() {
        searchService.model.no_result = false;
        var trns = searchService.model.trns;
        var searchResults = searchService.model.data.searchResults;
        if (searchResults.lots && searchResults.lots.length == 1) {
            trns.lots = trns.lot;
        }

        if (searchResults.catalogs && searchResults.catalogs.length == 1) {
            trns.catalogs = trns.catalog;
        }

        if (searchResults.tenders && searchResults.tenders.length == 1) {
            trns.tenders = trns.tender;
        }

        if (searchResults.products && searchResults.products.length == 1) {
            trns.products = trns.product;
        }

        if (searchResults.suppliers && searchResults.suppliers.length == 1) {
            trns.suppliers = trns.supplier;
        }

        if (searchResults.themeWorlds && searchResults.themeWorlds.length == 1) {
            trns.themeWorlds = trns.themeWorld;
        }
        if (!searchService.hasCats() && !searchService.hasProducts() && !searchService.hasLots() && !searchService.hasTenders()
            && !searchService.hasThemeWorlds()) {
            searchService.model.no_result = true;
        }
    }

    function updateSearchFilter(response) {
        if (searchService.model.data.searchResults.filters) {
            searchFilter.setSearchFilterData(searchService.model.data.searchResults.filters);
            if (response) {
                var facets = impactX.isDefined(response, 'data.searchResults.attributeSearch.facetResults');
                SearchFilter.setFacets(facets ? facets : []);
                var productLabelGroups = impactX.isDefined(response, 'data.searchResults.filters.productLabelGroups');
                SearchFilter.setProductLabelGroups(productLabelGroups ? productLabelGroups : []);
                var energyLabelGroups = impactX.isDefined(response, 'data.searchResults.filters.energyLabelGroups');
                SearchFilter.setEnergyLabelGroups(energyLabelGroups ? energyLabelGroups : []);
                var productFamilies = impactX.isDefined(response, 'data.searchResults.filters.productFamily.entries');
                SearchFilter.setProductFamilies(productFamilies ? productFamilies : []);
                var procurementGroups = impactX.isDefined(response, 'data.searchResults.filters.procurementGroup.entries');
                SearchFilter.setProcurementGroups(procurementGroups ? procurementGroups : []);
                var countries = impactX.isDefined(response, 'data.searchResults.filters.country.entries');
                SearchFilter.setCountries(countries ? countries : []);
            } else {
                SearchFilter.resetAllFilters();
            }
        } else {
                SearchFilter.resetAllFilters();
        }
    }

    function search(endpoint, filter) {
        var usedFilter = filter ? filter : SearchFilter.getFilters();
        self.lastSearchInput = (usedFilter && usedFilter.searchInput) ? usedFilter.searchInput.value : null;
        return dataGen.postAsForm(searchService.model, {
            filters: usedFilter,
            numberOfProductRows: NUMBER_OF_PRODUCTS
        }, endpoint, null, false).then(function (response) {
            updateLabels();
            if (!filter) {
                updateSearchFilter(response);
            }
            searchId = impactX.isDefined(response, 'data.searchResults.searchId');

            return response;
        });
    }

    function searchInfinite(endpoint, pageNumber, pageSize, justNewProducts, cscId, checkOutCatId, alternateUserId, rfqhId) {
        return dataGen.postAsForm(searchService.model, {
            filters: searchFilter.getSearchFilterData(),
            pagenumber: pageNumber,
            pagesize: pageSize,
            cscId: cscId || 0,
            justNewProducts: justNewProducts,
            checkOutCatId: checkOutCatId || 0,
            alternateUserId: alternateUserId || 0,
            rfqhId: rfqhId || 0
        }, endpoint, false, justNewProducts).then(function () {
            if (!justNewProducts) {
                updateLabels();
                updateSearchFilter();
            }
        });
    }

    this.searchInfinite = function (endpoint, pageNumber, pageSize, justNewProducts, forProductView, cscId, checkOutCatId, alternateUserId, rfqhId) {
        var contextFilterPromise = searchFilter.updateContextFilter($routeParams, forProductView).then(
            function () {
                return searchInfinite(endpoint, pageNumber, pageSize, justNewProducts, cscId, checkOutCatId, alternateUserId, rfqhId);
            }
        );
        searchFilter.getSearchFilterData().forProductView = false;
        return contextFilterPromise;
    };

    /**
     * @param cscId set for product selection (without basket link) to receive product with a price.
     */
    this.handleInfiniteProductSearch = function (scope, lastTopIndex, stepSize, preLoadingNumber, forProductView, updateFilterData,
                                                 cscId, checkOutCatId, alternateUserId, rfqhId) {
        scope.topIndexVirtualRepeat = {value: 0};
        scope.currentPage = {value: 1};
        scope.fetchInProgress = {value: false};
        scope.fetchMoreInProgress = {value: false};
        scope.fetchLessInProgress = {value: false};
        scope.topIndexVirtualRepeat.value = lastTopIndex;
        scope.currentPage.value = Math.floor(lastTopIndex / stepSize) + 1;
        var minValueLoaded = (scope.currentPage.value - 1) * stepSize;
        SearchProcessService.activateSearchProcess();
        return searchService.searchInfinite("/search/productsinfinite", scope.currentPage.value, stepSize,
            false, forProductView, cscId, checkOutCatId, alternateUserId, rfqhId).then(function () {
            scope.data = searchService.model.data;
            var preLoadArray = new Array(minValueLoaded);

            lastTopIndex = 0;
            scope.data.searchResults.products = preLoadArray.concat(searchService.model.data.searchResults.products);

            scope.trns = searchService.model.trns;
            scope.trns.addToFavorites = TranslationService.get('addToFavorites');
            scope.trns.removeFromFavorites = TranslationService.get('removeFromFavorites');
            scope.trns.addToProductComparison = TranslationService.get('addToProductComparison');
            scope.no_result = scope.data.searchResults.numOfProducts < 1;
            updateFilterData();
            scope.dynamicItems = {
                //needs to be init by first call
                length: scope.data.searchResults.numOfProducts,
                toLoad: stepSize,
                minValueLoaded: minValueLoaded,
                getItemAtIndex: function (index) {
                    if (index > scope.data.searchResults.products.length - preLoadingNumber) {
                        this.fetchMoreItems(index);
                    }
                    if (index - preLoadingNumber < this.minValueLoaded) {
                        this.fetchPreviousItems(index);
                    }
                    if (index > scope.data.searchResults.products.length) {
                        return null;
                    }
                    if (index < this.minValueLoaded) {
                        return null;
                    }

                    return scope.data.searchResults.products[index];
                },

                getLength: function () {
                    return Math.min(scope.data.searchResults.products.length + stepSize, this.length);
                },

                fetchMoreItems: function (index) {
                    if (!scope.fetchInProgress.value && this.toLoad < this.length) {
                        scope.fetchInProgress.value = true;
                        scope.fetchMoreInProgress.value = true;
                        this.toLoad = Math.min(this.toLoad + stepSize, this.length);
                        scope.currentPage.value++;
                        searchService.searchInfinite("/search/productsinfinite", scope.currentPage.value, stepSize, true,
                            forProductView, cscId, checkOutCatId, alternateUserId, rfqhId).then(function () {
                            scope.data.searchResults.products = scope.data.searchResults.products.concat(searchService.model.data.searchResults.products);
                            scope.fetchInProgress.value = false;
                            scope.fetchMoreInProgress.value = false;
                            updateFilterData();
                        });
                    }
                },
                fetchPreviousItems: function (index) {
                    if (!scope.fetchInProgress.value && this.minValueLoaded > index - preLoadingNumber && this.minValueLoaded > 0) {
                        scope.fetchInProgress.value = true;
                        scope.fetchLessInProgress.value = true;
                        this.minValueLoaded = Math.max(this.minValueLoaded - stepSize, 0);
                        var minValue = this.minValueLoaded;
                        searchService.searchInfinite("/search/productsinfinite", Math.floor(this.minValueLoaded / stepSize) + 1,
                            stepSize, true, forProductView, cscId, checkOutCatId, alternateUserId, rfqhId).then(function () {
                            for (var i = minValue; i < minValue + stepSize; i++) {
                                scope.data.searchResults.products[i] = searchService.model.data.searchResults.products[i - minValue];
                            }
                            scope.fetchInProgress.value = false;
                            scope.fetchLessInProgress.value = false;
                            updateFilterData();
                        });
                    }
                }
            };

        })
    };

    this.search = function (endpoint, forProductView) {
        var contextFilterPromise = searchFilter.updateContextFilter($routeParams, forProductView).then(
            function () {
                return search(endpoint);
            }
        );
        searchFilter.getSearchFilterData().forProductView = false;
        return contextFilterPromise;
    };

    this.hasTenders = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfTenders > 0
        }

        return result;
    };

    this.hasLots = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfLots > 0
        }

        return result;
    };

    this.hasThemeWorlds = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfThemeWorlds > 0
        }

        return result;
    };

    this.hasProducts = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfProducts > 0
        }

        return result;
    };

    this.hasCats = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfCats > 0
        }

        return result;
    };

    this.hasManufacturer = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfManufacturers > 0
        }

        return result;
    };

    this.hasSuppliers = function () {
        var result = false;
        var searchResult = searchService.model.data.searchResults;
        if (searchResult) {
            result = searchResult.numOfSuppliers > 0
        }

        return result;
    };

    this.setNumberOfProductRows = function(numberOfProductRows) {
        NUMBER_OF_PRODUCTS = numberOfProductRows;
    };

    this.getNumberOfProductRows = function() {
        return NUMBER_OF_PRODUCTS;
    }

    self.getSearchId = function () {
        return searchId;
    }

    this.isGlobalSearchFocused = function () {
        return self.globalSearchFocused;
    }

    this.setGlobalSearchFocused = function (value) {
        self.globalSearchFocused = value;
    }
}
